import styled from 'styled-components'
import { Button, ButtonOutline } from '../../../commons/Button'
import { Link } from 'react-router-dom'

export const CatalogCart = styled.div`
  margin-bottom: 3.5rem;
`
export const Title = styled.h1`
  margin: 2rem 0 5rem 0;
`

export const CartProductsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  max-height: 50vh;
  overflow-y: auto;
  margin-top: 3rem;
  @media ${({ theme }) => theme.screens.lg} {
    max-height: 70vh;
  }
`

export const GoToPaymentButton = styled(Button)`
  margin-left: auto;
  display: flex;
  margin-top: 2rem;
  width: 25.2rem;
  height: 5.8rem;
  justify-content: center;
  align-items: center;
  @media ${({ theme }) => theme.screens.sm} {
    margin: 32px auto 0;
    width: 100%;
  }
`

export const ClearCartButton = styled(ButtonOutline)`
  display: flex;
  margin-top: 1rem;
  width: 25.2rem;
  height: 5.8rem;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  @media ${({ theme }) => theme.screens.sm} {
    margin: 1rem auto 0;
    width: 100%;
  }
`

export const BackToHomeButton = styled(GoToPaymentButton)`
  margin-left: 0;
  display: flex;
  margin-top: 2rem;
  width: 25.2rem;
  height: 5.8rem;
  justify-self: center;
  justify-content: center;
  align-items: center;
  @media ${({ theme }) => theme.screens.sm} {
    margin: 32px auto 0;
    width: 100%;
  }
`

export const ButtonLink = styled(Link)``

export const InvoiceMiddleInformation = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  margin-left: auto;
  flex-wrap: wrap;
  @media ${({ theme }) => theme.screens.sm} {
    margin: 0 auto;
    justify-content: center;
    margin-left: initial;
  }
`

export const InvoiceValuesWrapper = styled.div``

export const CommomInvoiceInformationLabel = styled.div`
  font-weight: 400;
  font-size: ${({ theme }) => theme.fontSize.sm};
  line-height: 1.4rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.mono.greyDarker};
`

export const CommomInvoiceInformationValue = styled.div`
  font-weight: 400;
  font-size: ${({ theme }) => theme.fontSize.sm};
  line-height: 1.7rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.mono.black};
`

export const TotalInvoiceInformationLabel = styled.div`
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSize.sm};
  line-height: 1.7rem;
  color: ${({ theme }) => theme.colors.mono.black};
`

export const TotalInvoiceInformationValue = styled.div`
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSize.md};
  line-height: 2.2rem;
  letter-spacing: -0.3px;
  color: ${({ theme }) => theme.colors.primary.default};
`

export const InvoiceInformation = styled.div`
  margin-top: 2rem;
  min-height: 69px;
  background: ${({ theme }) => theme.colors.mono.greyLight};
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 1.5rem 5rem;
  max-width: fit-content;
  margin-left: auto;
`